export default __webpack_public_path__ + "static/media/q30.b8bc7a25.png";